import PropTypes from 'prop-types'

const alignItems = PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline'])
const type = PropTypes.oneOf(['container', 'item']).isRequired
const flexDirection = PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse'])
const justifyContent = PropTypes.oneOf(
  ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'],
)

export const defaultFlexBox = {
  alignItems: 'stretch',
  flexDirection: 'row',
  justifyContent: 'flex-start',
}

export default {
  alignItems,
  type,
  flexDirection,
  justifyContent,
}
